import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import CirclesBackgroundBlue from '@react/images/circles-background-blue.png';
import { BodyLarge, ButtonDarkLarge, H2 } from '@styled';
import { mediaQueries } from '@general/breakpoints';

const ContainerStyled = styled.div`
    background-image: url(${CirclesBackgroundBlue});
    background-size: cover;
    padding: 42px 24px;
    position: relative;

    @media ${mediaQueries.md} {
        padding: 52px 202px;
    }
`;

const NwpCtaPanel = () => {
    const history = useHistory();

    return (
        <ContainerStyled>
            <H2 className="text-center text-white">Meet Our Cutting-Edge Networking Platform</H2>
            <BodyLarge className="mt-1rem text-center text-white">
                We've made it easy to list your available properties, get recommended matches for prospective clients,
                and set up meetings with property owners, landlords and tenants.
            </BodyLarge>

            <div className="mt-1rem text-center">
                <ButtonDarkLarge
                    as="a"
                    href="/my-icsc"
                    onClick={e => {
                        e.preventDefault();
                        history.push('/my-icsc');
                    }}
                >
                    Learn More
                </ButtonDarkLarge>
            </div>
        </ContainerStyled>
    );
};

export default NwpCtaPanel;
